import { jsxs, jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { AnimationSpinner } from "../AnimationSpinner/index.js";
import { Tooltip } from "../Tooltip/index.js";
import { cn as clsx } from "../../helpers/react.js";
import { withThemeAndSize } from "../withThemeAndSize/index.js";
import '../../assets/index40.css';const timeCell = "_timeCell_vqmpa_2";
const interactable = "_interactable_vqmpa_13";
const label = "_label_vqmpa_19";
const time = "_time_vqmpa_2";
const dateTime = "_dateTime_vqmpa_21";
const bigValue = "_bigValue_vqmpa_45";
const date = "_date_vqmpa_21";
const spinner = "_spinner_vqmpa_94";
const spinnerAnimation = "_spinnerAnimation_vqmpa_1";
const s = {
  timeCell,
  interactable,
  label,
  time,
  dateTime,
  bigValue,
  date,
  spinner,
  spinnerAnimation
};
const TimeCell = withThemeAndSize(
  forwardRef(
    ({ className, label: label2, primaryDateValue, secondaryDateValue, isBigValue, isSpinnerEnabled, interactable: interactable2, ...rest }, ref) => {
      let timeToShow = primaryDateValue == null ? void 0 : primaryDateValue.value;
      return /* @__PURE__ */ jsxs("div", { ...rest, className: clsx(s.timeCell, className, { [s.interactable]: interactable2 }), ref, children: [
        /* @__PURE__ */ jsx(Tooltip, { content: label2 == null ? void 0 : label2.tooltip, side: "top", children: /* @__PURE__ */ jsx("span", { "data-testid": label2 == null ? void 0 : label2.testId, className: clsx(s.label, { [s.bigValue]: isBigValue }), children: label2 == null ? void 0 : label2.value }) }),
        isSpinnerEnabled && /* @__PURE__ */ jsx(AnimationSpinner, {}),
        /* @__PURE__ */ jsx(Tooltip, { content: primaryDateValue == null ? void 0 : primaryDateValue.tooltip, side: "top", children: /* @__PURE__ */ jsxs("div", { className: s.dateTime, children: [
          /* @__PURE__ */ jsx("span", { "data-testid": primaryDateValue == null ? void 0 : primaryDateValue.testId, className: clsx(s.time, { [s.bigValue]: isBigValue }), children: timeToShow }),
          Boolean(secondaryDateValue && secondaryDateValue.value) && /* @__PURE__ */ jsx("span", { "data-testid": secondaryDateValue == null ? void 0 : secondaryDateValue.testId, className: s.date, children: secondaryDateValue == null ? void 0 : secondaryDateValue.value })
        ] }) })
      ] });
    }
  )
);
export {
  TimeCell
};
